import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/sys' : '/sys'
//邮件初始模板
export function approvalDetails(obj) {
  return request({
    url: urlPrefix + '/salaryApproval/queryListPageQuery',
    method: 'post',
    params: obj
  });
}
//邮件设置
export function setEmail(obj) {
  return request({
    url: urlPrefix + '/salaryApproval/submitApproval',
    method: 'post',
    params: obj
  });
}
//邮件确认
export function confirmEmail(obj) {
  return request({
    url: urlPrefix + '/taxManage/confirmEmail',
    method: 'post',
    params: obj
  });
}

